import Feedback from './Feedback'
import './Feedback.css'

export default Feedback



// WEBPACK FOOTER //
// ./src/features/Feedback/components/Feedback/index.js